"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    defaultConfig: function() {
        return defaultConfig;
    },
    HadronCollider: function() {
        return HadronCollider;
    },
    default: function() {
        return _default;
    }
});
var _accelerator = /*#__PURE__*/ _interopRequireDefault(require("./Accelerator"));
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
var __generator = (void 0) && (void 0).__generator || function(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return(g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g);
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var defaultConfig = {
    observe: false,
    observeConfig: {
        rootMargin: "-250px 0px",
        threshold: 0.1
    }
};
var HadronCollider = /*#__PURE__*/ function() {
    "use strict";
    function HadronCollider(components) {
        var config = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        _classCallCheck(this, HadronCollider);
        this.components = [];
        this.loadedComponents = [];
        this.config = {};
        this.observers = new Map();
        this.on = function() {};
        this.fire = function() {};
        if (HadronCollider._instance) {
            return HadronCollider._instance;
        }
        this.components = components;
        this.config = Object.assign({}, defaultConfig, config);
        this.observers = new Map();
        this.accelerator = new _accelerator.default();
        this.on = this.accelerator.subscribe.bind(this.accelerator);
        this.fire = this.accelerator.publish.bind(this.accelerator);
        this.fire("hadron-init", {
            _hadron: this,
            components: components,
            config: config
        });
        HadronCollider._instance = this;
    }
    var _proto = HadronCollider.prototype;
    /**
     * @deprecated use the `run` function.
     */ _proto.loadEvents = function loadEvents() {
        console.warn("loadEvents is deprecated, use the run function instead.");
        this.run();
    };
    /**
     * Loops through all components passed to the Hadron and loads them.
     */ _proto.run = function run() {
        var _this = this;
        var load = function() {
            var _ref = _asyncToGenerator(function(component) {
                return __generator(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            if (!document.querySelector(component.target)) {
                                return [
                                    2
                                ];
                            }
                            return [
                                4,
                                _this.loadComponent(component)
                            ];
                        case 1:
                            _state.sent();
                            return [
                                2
                            ];
                    }
                });
            });
            return function load(component) {
                return _ref.apply(this, arguments);
            };
        }();
        var _this1 = this;
        var deferredLoad = function() {
            var _ref = _asyncToGenerator(function(component) {
                var elements;
                return __generator(this, function(_state) {
                    if (!document.querySelector(component.target)) {
                        return [
                            2
                        ];
                    }
                    elements = document.querySelectorAll(component.target);
                    elements.forEach(function(element) {
                        var observer = new IntersectionObserver(function(param) {
                            var _param = _slicedToArray(param, 1), entry = _param[0];
                            if (entry.isIntersecting) {
                                load(component);
                                elements.forEach(observer.unobserve);
                            }
                        }, _this1.config.observeConfig);
                        observer.observe(element);
                    });
                    return [
                        2
                    ];
                });
            });
            return function deferredLoad(component) {
                return _ref.apply(this, arguments);
            };
        }();
        if (this.config.observe) {
            this.instantComponents.forEach(function(component) {
                return load(component);
            });
            this.deferredComponents.forEach(function(component) {
                return deferredLoad(component);
            });
        } else {
            this.components.forEach(function(component) {
                return load(component);
            });
        }
    };
    _proto.loadComponent = function loadComponent(component) {
        var _this = this;
        return _asyncToGenerator(function() {
            var Component;
            return __generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            component.file()
                        ];
                    case 1:
                        Component = new (_state.sent());
                        Component.fire("load-component");
                        _this.loadedComponents.push(Component);
                        _this.fire("component-loaded", {
                            component: component,
                            Component: Component
                        });
                        _this.fire("component-".concat(Component.constructor._name, "-loaded"), {
                            component: component,
                            Component: Component
                        });
                        return [
                            2
                        ];
                }
            });
        })();
    };
    HadronCollider.getInstance = function getInstance() {
        if (HadronCollider._instance) {
            return HadronCollider._instance;
        }
        throw new Error("Hadron Collider not correctly initialized.");
    };
    _createClass(HadronCollider, [
        {
            key: "instantComponents",
            get: function get() {
                return this.components.filter(function(component) {
                    return component.instant;
                });
            }
        },
        {
            key: "deferredComponents",
            get: function get() {
                return this.components.filter(function(component) {
                    return !component.instant;
                });
            }
        }
    ]);
    return HadronCollider;
}();
var _default = HadronCollider;
